// src/modal/cargamento/modalCargamentoPaquete.jsx

import React, { useState, useEffect, useRef} from "react";
import { Box, Button, Modal, TextField, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { getOne } from "../../services/stockTejido.services";
import { updateVentaStock } from "../../services/pedidoVentaTejido.services";
import { PostCargaPedido } from "../../services/pedidoVentaTejido.services";
import { toast } from "react-toastify";
import secureStorage from "../../utils/secureStorage";

const ModalCargamentoTejido = ({ open, onClose, registro, disableAutoFocus }) => {
  const [serie, setSerie] = useState("");
  const [datos, setDatos] = useState(null);
  const inputRef = useRef(null); 

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);



  const USER = parseInt(secureStorage.getItem("id"));
  const Cod_empresa = parseInt(secureStorage.getItem("cod_empresa"));
  
  useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus(); // enfocar el input al abrir modal
    } else {
      setSerie("");
      setDatos(null);
      focusInputWhenReady(inputRef); 
    }
  }, [open]);

  
  function focusInputWhenReady(ref) {
  function tryFocus() {
    if (ref.current) {
      ref.current.focus();
    } else {
      requestAnimationFrame(tryFocus);
    }
  }
  tryFocus();
}

  const handleBuscarSerie = async () => {
    if (serie.trim().length > 5) {
      try {
        const response = await getOne(serie);
        setDatos(response);

        const formattedCod = response.cod.replace(/^[A-Z]-/, "").trim().toUpperCase();
        const codDelPedido = (registro?.producto || "").trim().toUpperCase();

        if (formattedCod !== codDelPedido) {
          toast.error("El código del producto no coincide con el pedido", { position: "top-center" });
          setDatos(null);
          return;
        }

        toast.success("Producto verificado correctamente", { position: "top-center" });
      } catch (error) {
         console.error("Error al obtener la serie:", error); 
        toast.error("Serie no encontrada", { position: "top-center" });
        setDatos(null);
      }
    }
  };

const handleRegistrar = async () => {
  if (serie.trim().length <= 5) {
    toast.error("Ingrese una serie válida", { position: "top-center" });
    return;
  }

  // ✅ No permitir registrar más si ya alcanzó el total
  if (registro.total_cargas >= registro.cantidad) {
    toast.error("Este pedido ya fue completado. No se pueden agregar más cargas.", { position: "top-center" });
    return;
  }

  try {
    const response = await getOne(serie);
    console.log("🚀 ~ handleRegistrar ~ response:", response)
    setDatos(response);

    // ✅ Comparar descripción
    const descripcionProducto = (response.cod || "").trim().toUpperCase();
    const descripcionPedido = (registro.producto || "").trim().toUpperCase();

    if (descripcionProducto !== descripcionPedido) {
      toast.error(`El producto "${descripcionProducto}" no coincide con el pedido de venta "${descripcionPedido}"`, {
        position: "top-center",
        autoClose: 6000
      });
      setDatos(null);
      return;
    }

    // ✅ Validar alto y largo
    const altoStock = parseFloat(response.alto);
    const largoStock = parseFloat(response.largo);
    const altoPedido = parseFloat(registro.alto);
    const largoPedido = parseFloat(registro.largo);

    if (altoStock !== altoPedido) {
    toast.error(`❌ El alto del producto ${altoStock}m no coincide con el alto del pedido de ${altoPedido}m`, {
      position: "top-center",
      autoClose: 3000
    });
    setDatos(null);
    return;
    }

    if (largoStock !== largoPedido) {
      toast.error(`❌ El largo del producto ${largoStock}m no coincide con el largo del pedido ${largoPedido}m`, {
        position: "top-center",
        autoClose: 3000
      });
      setDatos(null);
      return;
    }


    const valuesToSend = {
      id_pedido: registro.id,
      cod_empresa: Cod_empresa,
      id_usuario: USER,
      n_pedido: registro.n_pedido,
      cantidad: 1,
      serie: serie,
      descripcion: response.descripcion,
      id_vehiculo: registro.id_vehiculo,
    };

    const edit = {
      id_pedidoVenta: registro.n_pedido,
    };

    await PostCargaPedido(valuesToSend);
    await updateVentaStock(response.id, edit);

    toast.success("Registro exitoso", { position: "top-center" });
    setSerie("");
    setDatos(null);
  } catch (error) {
    console.error("Error al registrar:", error);
    const mensaje = error?.response?.data?.message || error?.message || "Ocurrió un error";
    toast.error(mensaje, { position: "top-center" });
    setDatos(null);
  }
};



  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          backgroundColor: colors.primary[600],
          padding: "20px",
          margin: "auto",
          marginTop: "10%",
          width: "400px",
          borderRadius: "8px",
        }}
      >
        <h2>{registro?.producto} {registro?.alto}m x {registro?.largo}m
</h2>
        <TextField
          fullWidth
          label="Serie"
          value={serie}
          onChange={(e) => setSerie(e.target.value)}
          sx={{ mt: 2 }}
          inputRef={inputRef}
        />
        <Box display="flex" justifyContent="space-between" mt={3}>
          <Button variant="outlined" color="secondary" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="contained" sx={{ backgroundColor: "rgb(206, 220,0)", borderRadius: "20px" }} onClick={handleRegistrar}>
            Registrar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalCargamentoTejido;
